import { StyleSheet } from 'react-native';
import { Dimensions } from 'react-native';
let deviceWidth = Dimensions.get('window').width;
import { Platform } from 'react-native';
if (Platform.OS === 'ios') {
  global.platform = 'ios';
} else if (Platform.OS === 'android') {
  global.platform = 'android';
} else if (Platform.OS === 'web') {
  global.platform = 'web';
} else {
  global.platform = 'web';
}
export default StyleSheet.create({
  contentContainer: {
    flexGrow: 1,
    justifyContent: 'flex-end',
  },

  alignTextCenter: {
    textAlign: 'center',
  },

  justContntLeft: {
    justifyContent: 'flex-start',
  },

  justContentSpaceBetween: {
    justifyContent: 'space-between',
  },

  infoImage: {
    width: 25,
    height: 25,
    margin: 10,
  },
  closeInfo: {
    color: 'black',
    textAlign: 'center',

    margin: 10,
    marginTop: 20,
  },

  chatBoldText: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  chatBoldTextIOS: {
    fontFamily: 'SFProTextbold',
    //fontSize: 18,
    fontWeight: 'bold',
  },
  closeIcon: {
    width: 10,
    height: 10,
  },
  row: {
    flexDirection: 'row',
  },

  operatorConnect: {
    flexDirection: 'column',
    alignSelf: 'center',
  },
  renderBox: {
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 20,
  },
  contentonkeyboard: {
    flexGrow: 1,
    justifyContent: 'flex-end',
    width: '100%',
  },
  imageView: {
    flex: 1,
    justifyContent: 'center',
    alignSelf: 'center',
    margin: 1,
  },

  showInfoBoxView: {
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 20,
  },
  renderTimerText: {
    color: 'white',
    textAlign: 'center',
    fontSize: 15,
  },
  avatarImageView: {
    marginBottom: 100,
    marginTop: -46,
    marginLeft: 10,
  },
  chatleftcorner: {
    width: 0,
    height: 0,
    borderLeftWidth: 15,
    borderRightWidth: 15,
    borderBottomWidth: 30,
    backgroundColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: '#f5f5f5',
    marginBottom: 5,
    marginRight: -25,
  },
  chatrightcorner: {
    width: '0%',
    height: '0%',
    borderLeftWidth: 15,
    borderRightWidth: 15,
    borderBottomWidth: 30,
    backgroundColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'rgb(209, 90, 94)',
    marginBottom: 5,
    marginRight: 4,
    marginLeft: -23,
    //marginLeft: -70,
    zIndex: 0,
  },
  msgContainer: {
    marginRight: 50,
    margin: 5,
    // maxWidth: deviceWidth <= 768 ? "" : "80%",
    maxWidth: '80%',
    margin: 5,
    marginRight: 50,
    left: 0,
    padding: 10,
    backgroundColor: '#f5f5f5',
    borderRadius: 14,
    borderBottomLeftRadius: 2,
    minWidth: '10%',
    overflow: 'hidden',
    marginBottom: 20,
  },
  buttonsRow: {
    zIndex: -999,
    flexWrap: 'wrap',
    flexDirection: 'row',
    margin: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatButton: {
    height: 33,
    // margin: 2,
    borderWidth: 1,
    borderColor: '#f14d31',
    backgroundColor: 'white',
    borderRadius: 17,
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.75,
    flexDirection: 'row',
  },
  backgroundOrange: {
    backgroundColor: '#f14d31',
  },
  chatButtonText: {
    fontSize: 13,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#f14d31',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
  colorWhite: {
    color: 'white',
  },
  width100Percent: {
    width: '100%',
  },
  agentTransfer: {
    //height: 54,
    borderRadius: 20,
    backgroundColor: '#f8f8f8',
    margin: 20,
    marginLeft: 18,
    paddingTop: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 15,
    flexDirection: 'row',
  },
  tranferedToAgent: { backgroundColor: '#f19058', opacity: 0.8 },
  agentImageView: { margin: 2, alignItems: 'center', marginLeft: 15 },
  agentImage: {
    width: 32.6,
    height: 34,
    marginLeft: 5,
    position: 'absolute',
  },
  transferText: {
    fontSize: 13,
    color: '#989898',
    padding: 10,
    paddingLeft: 25,
    alignItems: 'center',
    fontFamily: 'SFProText',
  },
  agentConnectedText: {
    fontSize: 13,
    padding: 5,
    alignItems: 'center',
    fontFamily: 'SFProText',
    // color: "#273a4e",
    color: 'black',
    textAlign: 'center',
  },
  voice: { marginLeft: -10 },

  widgetWrapper: {
    width: '100%',
    padding: 10,
    paddingBottom: 30,
  },

  widgetBody: {
    borderColor: '#b8b8b8',
    borderWidth: 1,
    borderRadius: 20,
    padding: 15,
  },

  widgetContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },

  widgetBox: {
    width: '33%',
    padding: 7,
  },

  editableWidgetBox: {
    width: '50%',
    padding: 3,
  },

  margnTop10: {
    marginTop: 10,
  },

  widgetHeader: {
    fontSize: 12,
    fontWeight: '300',
    textAlign: 'left',
    marginBottom: 5,
    color: '#707070',
    fontFamily: 'SFProText',
  },

  widgetLabel: {
    fontSize: 9,
    fontWeight: '300',
    textAlign: 'left',
    marginBottom: 5,
    color: '#707070',
    position: 'absolute',
    marginLeft: '2%',
    marginTop: -7,
    backgroundColor: 'white',
    paddingRight: 3,
    paddingLeft: 3,
    fontFamily: 'SFProText',
    zIndex: 999,
  },

  widgetValue: {
    fontSize: 12,
    fontWeight: Platform.OS != 'web' ? 'bold' : '600',
    textAlign: 'left',
    color: '#707070',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
    marginBottom: 5,
  },
  policyWidgetValue: {
    fontSize: 11,
    fontWeight: Platform.OS != 'web' ? 'bold' : '600',
    textAlign: 'left',
    color: '#707070',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
    marginBottom: 5,
  },

  widgetPicker:
    Platform.OS == 'web'
      ? {
          outlineWidth: 0,
          borderColor: '#b8b8b8',
          borderWidth: 1,
          borderRadius: 10,
          padding: 10,
          fontSize: 12,
          backgroundColor: 'white',
        }
      : {
          borderColor: '#b8b8b8',
          borderWidth: 1,
          borderRadius: 10,
          padding: 10,
          fontSize: 12,
          backgroundColor: 'white',
        },
  checkbox: {
    width: 13.4,
    height: 13.4,
    alignSelf: 'center',
  },
  checkBoxView: {
    // width: "50%",
    height: 33,
    minWidth: 67,
    margin: 2,
    borderWidth: 1,
    borderColor: '#f14d31',
    backgroundColor: 'white',
    borderRadius: 17,
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.75,
  },
  checkBoxText: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#f14d31',
    marginRight: 0,
    marginLeft: 2,
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
  checkBoxWrapper: {
    flexDirection: 'row',
    display: 'flex',
    flexWrap: 'wrap',
  },
  chatButtonCover: {
    padding: 2,
    width: '50%',
    minWidth: 67,
  },
  buttonWidth80: { width: '80%' },
  buttonWidth90: { width: '90%' },

  starstyle: { margin: 8 },
  ratings: { paddingVertical: 30 },

  underline: { textDecorationLine: 'underline' },
  chatLink: {
    fontFamily: "SFProText",
    color: '#ee7a67',
    padding: 0,
    fontSize:16
  },
  agent: { width: 20, height: 23 },
  mail: { width: 23, height: 17.3 },
  postal: { width: 30.4, height: 18.2 },
  info: { width: 14, height: 14 },
  textPadding: {
    padding: 7,
  },
  infoView: {
    width: 388,
    height: 195,
    borderWidth: 0.5,
    borderColor: '#b8b8b8',
    borderRadius: 20,
    backgroundColor: 'white',
    margin: 20,
    paddingTop: 14.7,
    paddingRight: 33.5,
    paddingBottom: 19,
    paddingLeft: 18,
  },

  chatIcons: {
    marginRight: 4,
  },

  width50Percent: {
    width: '50%',
  },

  quoteWidgetHeader: {
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },

  quoteWidgetHeaderImage: {
    width: 44,
    height: 30,
  },
  quoteWidgetHeaderText: {
    width: '80%',
    marginLeft: 11,
    fontFamily: 'SFProText',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    // lineHeight: "1.57",
    // letterSpacing: "normal",fontWeight
    textAlign: 'left',
    color: '#273a4e',
  },

  policySummaryText: {
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    // lineHeight: "1.83",
    // letterSpacing: "normal",
    textAlign: 'left',
    color: '#707070',
    paddingTop: 15,
  },

  fontSize11: {
    fontSize: 11,
  },
  fontSize9: {
    fontSize: 9,
  },

  marginBottom0: {
    marginBottom: 0,
  },

  quoteAmountWrapper: {
    margin: 10,
    padding: 20,
    borderRadius: 12,
    backgroundColor: '#ffe6e2',
  },

  quoteAmount: {
    fontSize: 18,
    fontWeight: '500',
    fontStyle: 'normal',
    // lineHeight: "1.22",
    // letterSpacing: "normal",
    textAlign: 'center',
    color: '#f14d31',
  },
  quoteAmountMonthly: {
    fontSize: 16,
    fontWeight: '500',
    fontStyle: 'normal',
    textAlign: 'center',
    color: '#f14d31',
    marginTop: 5,
  },
  chatTime: {
    fontSize: Platform.OS == 'web' ? 10 : 11,
    fontWeight: '300',
    color: '#b3b3b3',
    fontFamily: 'SFProText',
    textAlign: 'center',
    textAlign: 'right',
    marginTop: 3,
  },
  timerTextMsg: { color: '#273a4e', fontSize: 14, fontFamily: 'SFProText' },
});
